import { useContext, useEffect, useState } from '@wordpress/element';
import { CampoInput } from '@componentsNew/Input/CampoInput';
import EstruturaPostContext from '@pages/DicasOtimizacao/Context/EstruturaPostContext';

function PalavraChave({ nota, carregando }) {

  return (
    <CampoInput
      label={'Palavra - chave principal'}
      nota={nota}
      carregando={carregando}
      campoEstrutura={'palavra_chave'}
    />
  );
}

export default PalavraChave;
